import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../../../../icon/icon.module';

@Component({
    selector: 'lc-form-draft-indicator',
    standalone: true,
    imports: [CommonModule, IconModule],
    template: `
        @if (hasDraft) {
            <div class="draft-indicator">
                <span class="draft-text"> <strong>Em andamento:</strong> Rascunho salvo </span>
                <button
                    type="button"
                    class="draft-clear-btn"
                    (click)="onClearDraft.emit()"
                    title="Limpar rascunho"
                >
                    <icon-trash class="h-4 w-4" />
                </button>
            </div>
        }
    `,
    styles: [
        `
            .draft-indicator {
                @apply bg-blue-50 dark:bg-blue-200 border border-blue-400 text-blue-700 
                   px-4 py-3 rounded mb-4 flex justify-between items-center;
            }

            .draft-text {
                @apply text-sm;
            }

            .draft-clear-btn {
                @apply text-blue-700 dark:text-blue-400 cursor-pointer hover:text-blue-800 
                   dark:hover:text-blue-300 transition-colors duration-200;
            }
        `,
    ],
})
export class FormDraftIndicatorComponent {
    @Input() hasDraft: boolean = false;
    @Output() onClearDraft = new EventEmitter<void>();
}
